<div class="content-container">
    <mat-card class="login-component">
        <mat-card-header class="login-header">
            <mat-card-title class="mat-card-title">
                <mat-icon class="material-symbols-outlined">
                    domain
                </mat-icon>
                <span>
                    Organization: {{ this.itemEnvelope?.ItemId }}: {{ this.itemEnvelope?.ItemName }}
                </span>
            </mat-card-title>
            <mat-card-subtitle class="mat-card-subtitle">
                {{ subtitle }}
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <form>
                <div class="flex-direction-horizontal">
                    <div class="flex-container-basic">
                        <app-image srcPath="{{ this.itemEnvelope?.Document?.Item?.AvatarBlobPath == null ? appService.defaultImageUri : this.itemEnvelope?.Document?.Item?.AvatarBlobPath }}" isApiImage="{{ this.itemEnvelope?.Document?.Item?.AvatarBlobPath == null ? 'false' : 'true' }}" className="app-image-medium app-image-circle"></app-image>
                    </div>
                    <div class="flex-direction-vertical flex-container-basic">
                        <mat-form-field appearance="outline">
                            <mat-label>Name</mat-label>
                            <input *ngIf="itemEnvelope" matInput name="Name" placeholder="Name" [(ngModel)]="itemEnvelope.Document.Item.Name" />
                        </mat-form-field>
                    </div>
                </div>
            </form>
            <mat-tab-group (selectedTabChange)="onTabChange($event)">
                <br />
                <mat-tab label="General">
                    <br />
                </mat-tab>
                <mat-tab label="People">
                    <br />
                    <span class="{{ dynamicClassNamePersonSpan }}">
                        <app-chip-selector #personChipSelector label="People" className="width-medium-narrow" [isMultiSelect]="false" [availableItems]="availablePersons" [selectedItemIds]="selectedPersonIds"></app-chip-selector>
                        &nbsp;
                        &nbsp;
                        <mat-form-field appearance="outline">
                            <mat-label>Status</mat-label>
                            <mat-select #membershipStatusSelector name="Membershipstatuses" [(ngModel)]="selectedMembershipStatusId" (selectionChange)="onMembershipStatusChange($event)">
                                <mat-option *ngFor="let membershipStatus of availableMembershipStatuses" [value]="membershipStatus.MembershipStatusId">{{ membershipStatus.UID }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </span>
                    &nbsp;
                    &nbsp;
                    <button mat-button (click)="addPersonToOrganizationalUnit()" [disabled]="dynamicClassNamePersonSpan == 'expanding-span-expanded' && !(selectedPersonIds.length > 0 && selectedPersonIds != undefined)">
                        <mat-icon class="material-symbols-outlined" matTooltip="{{ dynamicClassNamePersonSpan == 'expanding-span-expanded' && !(selectedPersonIds.length > 0 && selectedMembershipStatusId != undefined) ? 'Select a person to enable this button' : '' }}">
                            {{ dynamicClassNamePersonSpan == 'expanding-span-expanded' && !(selectedPersonIds.length > 0 && selectedMembershipStatusId != undefined) ? 'warning' : 'add' }}
                        </mat-icon>
                        ADD PERSON
                    </button>
                    <button mat-button *ngIf="dynamicClassNamePersonSpan == 'expanding-span-expanded'" (click)="cancelAddPersonToOrganizationalUnit()">
                        <mat-icon class="material-symbols-outlined">
                            cancel
                        </mat-icon>
                        CANCEL
                    </button>
                    <br />
                    <table mat-table *ngIf="itemEnvelope" [dataSource]="organizationalUnitPersonsDatasource" class="mat-elevation-z8" matSort>
                        <ng-container matColumnDef="Avatar">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                            <td mat-cell *matCellDef="let organizationalUnitPerson">
                                <app-image srcPath="{{ getAvatarBlobPathFromPersonId(organizationalUnitPerson.PersonId) }}" isApiImage="true" class="margin-wide-right nudge-down-small" className="app-image-extra-small app-image-circle"></app-image>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="FirstName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
                            <td mat-cell *matCellDef="let organizationalUnitPerson">{{ getFirstNameFromPersonId(organizationalUnitPerson.PersonId) }}</td>
                        </ng-container>
                        <ng-container matColumnDef="LastName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
                            <td mat-cell *matCellDef="let organizationalUnitPerson">{{ getLastNameFromPersonId(organizationalUnitPerson.PersonId) }}</td>
                        </ng-container>
                        <ng-container matColumnDef="Status">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                            <td mat-cell *matCellDef="let organizationalUnitPerson">{{ getUIDFromMembershipStatusId(organizationalUnitPerson.MembershipStatusId) }}</td>
                        </ng-container>
                        <ng-container matColumnDef="Delete">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                            <td mat-cell *matCellDef="let organizationalUnitPerson">
                                <mat-icon class="material-symbols-outlined" (click)="deleteOrganizationalUnitPerson(organizationalUnitPerson)">
                                    delete
                                </mat-icon>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedOrganizationalUnitPersonColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedOrganizationalUnitPersonColumns"></tr>
                    </table>
                </mat-tab>
                <mat-tab label="Groups">
                    <br />
                    <form>
                        <span>
                            <app-chip-selector #groupsChipSelector label="Groups" className="width-medium-narrow" [isMultiSelect]="true" [availableItems]="availableGroups" [value]="selectedGroupIds"></app-chip-selector>
                        </span>
                    </form>
                </mat-tab>
                <mat-tab *ngIf="!isRevisionMode" label="History">
                    <div class="history-container">
                        <div class="history-container-section">
                            <app-history #appHistory *ngIf="this.itemEnvelope" [itemEnvelope]="this.itemEnvelope" [itemService]="this.itemService"></app-history>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
    </mat-card>
</div>
